export default "__VITE_ASSET__BEcwJRau__"